<template>
  <footer class="footer">
    <div class="footer-top">
      <!-- Left -->
      <div class="footer-left">
        <p class="description">
          {{ $t("message.hero_title1") }}
        </p>

        <nav class="links">
          <a href="/#whyChooseUs">{{ $t("message.footer_menu2") }}</a>
          <a href="/#howItWorks">{{ $t("message.footer_menu3") }}</a>
          <a href="/blogs">{{ $t("message.foo_Blogs") }}</a>
        </nav>
      </div>

      <!-- Right -->
      <div class="footer-right">
        <div class="store-group">
          <p class="store-group-title">{{ $t("message.footer_traveler_app") }}</p>
          <div class="store-buttons">
            <a :href="storeLinks.traveler.appStore" target="_blank" rel="noopener">
              <img
                src="@/assets/icons/app-store.svg"
                alt="Download the Traveler app on the App Store"
              />
            </a>
            <a :href="storeLinks.traveler.googlePlay" target="_blank" rel="noopener">
              <img
                src="@/assets/icons/google-play.svg"
                alt="Get the Traveler app on Google Play"
              />
            </a>
          </div>
        </div>

        <div class="store-group">
          <p class="store-group-title">{{ $t("message.footer_local_app") }}</p>
          <div class="store-buttons">
            <a :href="storeLinks.local.appStore" target="_blank" rel="noopener">
              <img
                src="@/assets/icons/app-store.svg"
                alt="Download the Local Host app on the App Store"
              />
            </a>
            <a :href="storeLinks.local.googlePlay" target="_blank" rel="noopener">
              <img
                src="@/assets/icons/google-play.svg"
                alt="Get the Local Host app on Google Play"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="footer-bottom">
      <p>© {{ $t("message.all_rights_reserved") }}</p>

      <div class="socials">
        <a href="https://www.linkedin.com/company/farrther/" target="_blank"><img src="@/assets/icons/linkedin.svg" alt="LinkedIn" /></a>
        <a href="https://www.facebook.com/people/Farrther/61583001917776/" target="_blank"><img src="@/assets/icons/facebook.svg" alt="Facebook" /></a>
        <a href="https://www.instagram.com/farrther.travel" target="_blank"><img src="@/assets/icons/instagram.svg" alt="Instagram" /></a>
      </div>
    </div>
  </footer>
</template>

<script setup>
const storeLinks = {
  traveler: {
    appStore: "https://apps.apple.com/us/app/farrther-traveler/id6752910699",
    googlePlay: "https://play.google.com/store/apps/details?id=com.farrther.traveler",
  },
  local: {
    appStore: "https://apps.apple.com/us/app/farrther-localguide/id6752910687",
    googlePlay: "https://play.google.com/store/apps/details?id=com.farrther.localguide",
  },
};
</script>

<style scoped>
.footer {
  background: #183a34;
  color: #cfd8d6;
  padding: 60px 80px 30px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.footer-left {
  max-width: 520px;
}

.description {
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.6;
}

.links {
  display: flex;
  gap: 28px;
}

.links a {
  color: #cfd8d6;
  text-decoration: none;
  font-size: 15px;
  opacity: 0.85;
}

.links a:hover {
  opacity: 1;
}

.footer-right {
  display: flex;
  align-items: flex-start;
  gap: 40px;
}

.store-group-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  opacity: 0.85;
}

.store-buttons {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.store-buttons img {
  height: 46px;
  cursor: pointer;
  display: block;
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 40px 0 24px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.socials {
  display: flex;
  gap: 18px;
}

.socials img {
  width: 22px;
  height: 22px;
  opacity: 0.8;
}

.socials img:hover {
  opacity: 1;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .footer {
    padding: 50px 24px 30px;
  }

  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-right {
    flex-wrap: wrap;
    gap: 28px;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}
</style>
